module.exports = __webpack_public_path__ + "img/BMW_logo_(white).b22fd2e5.svg";